import { SectionCard } from './section-card';
import { useEveProfile } from '@/hooks/use-eve-profile';

type NotifKey = 'whale' | 'wallet' | 'calls';
const LABELS: Record<NotifKey, string> = {
  whale: 'Whale-Alerts',
  wallet: 'Wallet-Alarme',
  calls: 'EVE-Calls',
};

export function NotificationsSection() {
  const { profile, update } = useEveProfile();
  const notif = profile.notifications ?? { whale: true, wallet: true, calls: true };

  async function toggle(key: NotifKey) {
    await update({ notifications: { ...notif, [key]: !notif[key] } });
  }

  return (
    <SectionCard title="Benachrichtigungen" description="Wovon EVE dich aktiv informiert.">
      {(Object.keys(LABELS) as NotifKey[]).map((key) => (
        <label key={key} className="flex items-center justify-between text-sm text-slate-200">
          <span>{LABELS[key]}</span>
          <input
            type="checkbox"
            role="switch"
            checked={Boolean(notif[key])}
            onChange={() => void toggle(key)}
            className="size-5 accent-amber-500"
          />
        </label>
      ))}
    </SectionCard>
  );
}
